// Cart Height
(function () {
  const CART_ROOT_SELECTOR = "cart-element.cart--root";

  function getSummaryEl(cartRoot) {
    return (
      cartRoot.querySelector(".cart--summary") ||
      cartRoot.querySelector(".cart--footer")
    );
  }

  function updateSummaryHeight(cartRoot) {
    if (!cartRoot) return;
    const summaryEl = getSummaryEl(cartRoot);
    if (!summaryEl) return;

    const h = Math.ceil(summaryEl.getBoundingClientRect().height);
    cartRoot.style.setProperty("--summary-height", `${h}px`);
  }

  function wire(cartRoot) {
    if (!cartRoot || cartRoot.__cuSummaryHeightWired) return;
    cartRoot.__cuSummaryHeightWired = true;

    updateSummaryHeight(cartRoot);

    const summaryEl = getSummaryEl(cartRoot);

    if (summaryEl && "ResizeObserver" in window) {
      const ro = new ResizeObserver(() => updateSummaryHeight(cartRoot));
      ro.observe(summaryEl);
      cartRoot.__cuSummaryHeightRO = ro;
    }

    window.addEventListener(
      "resize",
      () => updateSummaryHeight(cartRoot),
      { passive: true }
    );
  }

  function boot() {
    document.querySelectorAll(CART_ROOT_SELECTOR).forEach((root) => {
      wire(root);
      updateSummaryHeight(root);
    });
  }

  document.addEventListener("DOMContentLoaded", boot);

  document.addEventListener("cart:updated", boot);
  document.addEventListener("cart:refresh", boot);

  document.addEventListener("click", () => setTimeout(boot, 50), { passive: true });
})();


// PRODUCT VARIANT LIMIT
(() => {
  if (window.__LIMIT_ONE_INTERCEPTOR__) return;
  window.__LIMIT_ONE_INTERCEPTOR__ = true;

  const LOG = "[limit-one]";
  const CART_ADD_PATHS = ["/cart/add", "/cart/add.js"];

  const findAllAddToCartForms = () => {
    return Array.from(document.querySelectorAll('form[action^="/cart/add"], form[action*="/cart/add"]'));
  };

  const findSubmitButtons = (form) => {
    const btns = [];
    const b1 = form.querySelector('button[type="submit"][name="add"]');
    const b2 = form.querySelector('button[type="submit"]');
    const i1 = form.querySelector('input[type="submit"]');
    [b1, b2, i1].forEach((b) => b && btns.push(b));
    return Array.from(new Set(btns));
  };

  const ensureInlineMessage = (form) => {
    const localScope =
      form.closest('[role="dialog"]') ||
      form.closest('.quick-add') ||
      form.closest('.product-drawer') ||
      form.closest('product-options-element') ||
      form;

    let el = form.querySelector("[data-limit-one-inline]");
    if (el) return el;

    el = document.createElement("div");
    el.setAttribute("data-limit-one-inline", "true");
    el.style.marginTop = "12px";
    el.style.fontSize = "0.95em";
    el.style.display = "none";
    el.style.padding = "10px 12px";
    el.style.borderRadius = "2px";
    el.style.border = "1px solid rgba(251, 65, 65, 0.78)";
    el.style.background = "rgba(255, 173, 173, 0.59)";
    el.style.lineHeight = "1.2";

    const optionsContainer =
      localScope.querySelector(".product-options--container") ||
      form.querySelector(".product-options--container");

    if (optionsContainer && optionsContainer.parentNode) {
      optionsContainer.parentNode.insertBefore(el, optionsContainer.nextSibling);
    } else {
      form.appendChild(el);
    }

    return el;
  };


  const setInlineMessageAllForms = (text) => {
    const forms = findAllAddToCartForms();
    forms.forEach((form) => {
      const el = ensureInlineMessage(form);
      el.textContent = text || "";
      el.style.display = text ? "block" : "none";
    });
  };

  const setAddToCartDisabledAllForms = (disabled) => {
    const forms = findAllAddToCartForms();
    forms.forEach((form) => {
      const btns = findSubmitButtons(form);
      btns.forEach((btn) => {
        btn.disabled = !!disabled;
        btn.setAttribute("aria-disabled", disabled ? "true" : "false");
        if (disabled) btn.classList.add("is-disabled-limit-one");
        else btn.classList.remove("is-disabled-limit-one");
      });
    });
  };

  const injectCssOnce = () => {
    if (document.getElementById("limit-one-css")) return;
    const style = document.createElement("style");
    style.id = "limit-one-css";
    style.textContent = `
      .is-disabled-limit-one { opacity: .6 !important; cursor: not-allowed !important; }
    `;
    document.head.appendChild(style);
  };
  injectCssOnce();

  const showMessage = (msg) => {
    console.warn(LOG, msg);
    setInlineMessageAllForms(msg);
  };

  const clearMessage = () => setInlineMessageAllForms("");

  // ---------- Limit map + cart helpers ----------

  const getLimitMap = () => {
    const scripts = document.querySelectorAll('script[id^="variant-limit-map-"]');
    const map = {};
    scripts.forEach((s) => {
      try {
        const obj = JSON.parse(s.textContent || "{}");
        Object.assign(map, obj);
      } catch (e) {
        console.warn(LOG, "Bad JSON in", s.id, e);
      }
    });
    return map;
  };

  const isAddUrl = (url) => {
    if (!url) return false;
    try {
      const u = new URL(url, window.location.origin);
      return CART_ADD_PATHS.some((p) => u.pathname === p);
    } catch {
      return CART_ADD_PATHS.some((p) => String(url).includes(p));
    }
  };

  const fetchCart = async () => {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error(`cart.js failed: ${res.status}`);
    return res.json();
  };

  let cartCache = null;
  let cartCacheAt = 0;
  const getCartCached = async () => {
    const now = Date.now();
    if (!cartCache || now - cartCacheAt > 1500) {
      cartCache = await fetchCart();
      cartCacheAt = now;
    }
    return cartCache;
  };

  const isVariantInCart = async (variantId) => {
    const cart = await getCartCached();
    const line = (cart.items || []).find((it) => String(it.variant_id) === String(variantId));
    return (line?.quantity || 0) >= 1;
  };

  const shouldBlockAdd = async (variantId) => {
    const limitMap = getLimitMap();
    const limited = !!limitMap[String(variantId)];

    console.log(LOG, "Check add", { variantId: String(variantId), limited });

    if (!limited) return false;
    return await isVariantInCart(variantId);
  };

  // ---------- Variant change watcher (disable proactively) ----------

  const getSelectedVariantIdFromForms = () => {
    const forms = findAllAddToCartForms();
    for (const form of forms) {
      const idInput = form.querySelector('input[name="id"]');
      if (idInput?.value) return String(idInput.value);
    }
    return null;
  };

  const applyProactiveDisable = async () => {
    try {
      const variantId = getSelectedVariantIdFromForms();
      if (!variantId) return;

      const limitMap = getLimitMap();
      const limited = !!limitMap[String(variantId)];

      if (!limited) {
        setAddToCartDisabledAllForms(false);
        clearMessage();
        return;
      }

      const already = await isVariantInCart(variantId);
      if (already) {
        setAddToCartDisabledAllForms(true);
        showMessage("Limit 1 per order for this variant (already in your cart).");
      } else {
        setAddToCartDisabledAllForms(false);
        clearMessage();
      }
    } catch (e) {
      console.warn(LOG, "Proactive check failed (leaving enabled)", e);
      setAddToCartDisabledAllForms(false);
      clearMessage();
    }
  };

  let lastVariantId = null;
  setInterval(() => {
    const v = getSelectedVariantIdFromForms();
    if (v && v !== lastVariantId) {
      lastVariantId = v;
      cartCache = null;
      cartCacheAt = 0;
      applyProactiveDisable();
    }
  }, 250);

  document.addEventListener("change", () => applyProactiveDisable());
  document.addEventListener("cart:updated", () => {
    cartCache = null;
    cartCacheAt = 0;
    applyProactiveDisable();
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyProactiveDisable);
  } else {
    applyProactiveDisable();
  }

  // ---------- Intercept /cart/add.js (FETCH) ----------

  const originalFetch = window.fetch.bind(window);
  window.fetch = async (input, init) => {
    const url = typeof input === "string" ? input : input?.url;

    if (isAddUrl(url)) {
      try {
        let variantId = null;
        const body = init?.body;

        if (body instanceof FormData) {
          variantId = body.get("id");
        } else if (typeof body === "string") {
          try {
            const json = JSON.parse(body);
            variantId = json?.id;
          } catch {
            const params = new URLSearchParams(body);
            variantId = params.get("id");
          }
        } else if (body && typeof body === "object") {
          variantId = body.id;
        }

        if (variantId) {
          const block = await shouldBlockAdd(variantId);
          if (block) {
            setAddToCartDisabledAllForms(true);
            showMessage("Limit 1 per order for this variant (already in your cart).");

            return new Response(JSON.stringify({ status: 422, message: "Limit one" }), {
              status: 422,
              headers: { "Content-Type": "application/json" },
            });
          } else {
            setAddToCartDisabledAllForms(false);
            clearMessage();
          }
        } else {
          console.log(LOG, "Could not read variant id from fetch body", init?.body);
        }
      } catch (e) {
        console.warn(LOG, "Fetch intercept error (allowing add)", e);
      }
    }

    const res = await originalFetch(input, init);

    if (isAddUrl(url)) {
      cartCache = null;
      cartCacheAt = 0;
      setTimeout(applyProactiveDisable, 250);
    }

    return res;
  };

  // ---------- Intercept /cart/add.js (XHR) ----------

  const OrigOpen = XMLHttpRequest.prototype.open;
  const OrigSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.__limitOneUrl = url;
    return OrigOpen.call(this, method, url, ...rest);
  };

  XMLHttpRequest.prototype.send = function (body) {
    const url = this.__limitOneUrl;

    if (isAddUrl(url)) {
      (async () => {
        try {
          let variantId = null;

          if (body instanceof FormData) {
            variantId = body.get("id");
          } else if (typeof body === "string") {
            try {
              const json = JSON.parse(body);
              variantId = json?.id;
            } catch {
              const params = new URLSearchParams(body);
              variantId = params.get("id");
            }
          }

          if (variantId) {
            const block = await shouldBlockAdd(variantId);
            if (block) {
              setAddToCartDisabledAllForms(true);
              showMessage("Limit 1 per order for this variant (already in your cart).");
              try {
                this.abort();
              } catch {}
              return;
            } else {
              setAddToCartDisabledAllForms(false);
              clearMessage();
            }
          } else {
            console.log(LOG, "Could not read variant id from XHR body", body);
          }
        } catch (e) {
          console.warn(LOG, "XHR intercept error (allowing add)", e);
        }
      })();
    }

    const out = OrigSend.call(this, body);

    if (isAddUrl(url)) {
      cartCache = null;
      cartCacheAt = 0;
      setTimeout(applyProactiveDisable, 250);
    }

    return out;
  };
})();




// ========================================================
// AUTO THRESHOLD GIFT ($250)
// ========================================================

(() => {
  if (window.__AUTO_THRESHOLD__) return;
  window.__AUTO_THRESHOLD__ = true;

  const LOG = "[auto-threshold]";
  const THRESHOLD_CENTS = 25000; // $250
  const GIFT_VARIANT_ID = 44213368094974;
  const AUTO_PROP_KEY = "_auto_threshold_add";
  const AUTO_PROP_VALUE = "1";

  let running = false;

  const fetchCart = async () => {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error("cart.js failed");
    return res.json();
  };

  const hasAutoProp = (item) =>
    item?.properties?.[AUTO_PROP_KEY] === AUTO_PROP_VALUE;

  const addGift = async () => {
    console.log(LOG, "Adding gift");
    const fd = new FormData();
    fd.append("id", String(GIFT_VARIANT_ID));
    fd.append("quantity", "1");
    fd.append(`properties[${AUTO_PROP_KEY}]`, AUTO_PROP_VALUE);

    await fetch("/cart/add.js", {
      method: "POST",
      body: fd,
    });

    document.dispatchEvent(new Event("cart:updated"));
  };

  const removeGift = async (line) => {
    console.log(LOG, "Removing gift");
    const fd = new FormData();
    fd.append("line", String(line));
    fd.append("quantity", "0");

    await fetch("/cart/change.js", {
      method: "POST",
      body: fd,
    });

    document.dispatchEvent(new Event("cart:updated"));
  };

    const setGiftQuantityByLine = async (line, qty) => {
    console.log(LOG, "Setting gift quantity", { line, qty });
    const fd = new FormData();
    fd.append("line", String(line));
    fd.append("quantity", String(qty));

    await fetch("/cart/change.js", {
      method: "POST",
      body: fd,
    });

    document.dispatchEvent(new Event("cart:updated"));
  };

  const desiredQtyFromTotal = (totalCents) => {
    // +1 qty per $250. 0 if under $250.
    return Math.floor(totalCents / THRESHOLD_CENTS);
  };

  const evaluate = async () => {
    if (running) return;
    running = true;

    try {
      const cart = await fetchCart();
      const items = cart.items || [];

      let giftIndex = -1;
      let giftQty = 0;
      let totalExclGift = 0;

      items.forEach((item, i) => {
        const isGift =
          String(item.variant_id) === String(GIFT_VARIANT_ID) &&
          hasAutoProp(item);

        if (isGift) {
          giftIndex = i;
          giftQty = item.quantity || 0;
        } else {
          totalExclGift += item.final_line_price || 0;
        }
      });

      const desiredQty = desiredQtyFromTotal(totalExclGift);

      console.log(LOG, {
        totalExclGift,
        desiredQty,
        giftPresent: giftIndex !== -1,
        currentGiftQty: giftQty,
      });

      if (desiredQty <= 0) {
        if (giftIndex !== -1) {
          await setGiftQuantityByLine(giftIndex + 1, 0);
        }
        return;
      }

      if (giftIndex === -1) {
        await addGift();
        return;
      }

      if (giftQty !== desiredQty) {
        await setGiftQuantityByLine(giftIndex + 1, desiredQty);
      }
    } catch (e) {
      console.warn(LOG, "Error:", e);
    } finally {
      running = false;
    }
  };

  // Run after cart changes
  document.addEventListener("cart:updated", evaluate);

  // Run once on load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", evaluate);
  } else {
    evaluate();
  }

})();




// ========================================================
// DISABLE CART GIFT ITEM INTERACTIONS (title/image/qty)
// ========================================================
(() => {
  if (window.__CART_DISABLE_GIFT__) return;
  window.__CART_DISABLE_GIFT__ = true;
  const GIFT_VARIANT_ID = "44213368094974";
  const injectCssOnce = () => {
    if (document.getElementById("cu-cart-disable-css")) return;
    const style = document.createElement("style");
    style.id = "cu-cart-disable-css";
    style.textContent = `
      /* Disable ONLY quantity controls */
      .cu-disabled-gift .quantity-selector--minus,
      .cu-disabled-gift .quantity-selector--plus,
      .cu-disabled-gift .quantity-selector--input {
        pointer-events: none !important;
        cursor: not-allowed !important;
        opacity: 0.6 !important;
      }

      /* Disable ALL product links inside the gift line */
      .cu-disabled-gift a[href*="/products/"] {
        pointer-events: none !important;
        cursor: default !important;
        text-decoration: none !important;
      }

      /* Hide ONLY money text (keep layout/dividers) */
      .cu-disabled-gift .cart--item--price .money,
      .cu-disabled-gift .cart--item--total .money,
      .cu-disabled-gift .money {
        opacity: 0 !important;
      }

      /* Disable image link wrapper */
      .cu-disabled-gift a.cart--item--image {
        pointer-events: none !important;
        cursor: default !important;
      }

      /* Hide remove button */
      .cu-disabled-gift .quantity-selector--remove {
        display: none !important;
      }
    `;

    document.head.appendChild(style);
  };

  const getGiftItems = () =>
    Array.from(
      document.querySelectorAll(
        `.cart--item[data-variant-id="${GIFT_VARIANT_ID}"]`
      )
    );

  let isMoving = false;

  const moveGiftToBottom = () => {
    if (isMoving) return;

    const giftItems = getGiftItems();
    if (!giftItems.length) return;

    const container = giftItems[0].parentElement;
    if (!container) return;

    const itemsInContainer = Array.from(
      container.querySelectorAll(":scope > .cart--item")
    );
    if (!itemsInContainer.length) return;

    const lastItem = itemsInContainer[itemsInContainer.length - 1];
    if (lastItem && lastItem.getAttribute("data-variant-id") === GIFT_VARIANT_ID) {
      return;
    }

    isMoving = true;
    try {
      giftItems.forEach((item) => {
        if (item.parentElement === container) {
          container.appendChild(item);
        }
      });
    } finally {
      setTimeout(() => {
        isMoving = false;
      }, 0);
    }
  };

  const disableGiftItems = () => {
    injectCssOnce();

    getGiftItems().forEach((item) => item.classList.add("cu-disabled-gift"));

    moveGiftToBottom();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", disableGiftItems);
  } else {
    disableGiftItems();
  }

  document.addEventListener("cart:updated", disableGiftItems);
  document.addEventListener("cart:refresh", disableGiftItems);

  let rafPending = false;

  const observer = new MutationObserver(() => {
    if (isMoving || rafPending) return;

    rafPending = true;
    requestAnimationFrame(() => {
      rafPending = false;
      disableGiftItems();
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();